import * as yup from "yup";

// 비밀번호 찾기 폼 데이터 타입
export interface ForgotPasswordFormData {
  forgetUserId: string;
  forgetUserName: string;
}

// 비밀번호 찾기 폼 유효성 검사 스키마
export const forgotPasswordSchema = yup.object({
  forgetUserId: yup
    .string()
    .required("이메일 주소를 입력하세요.")
    .email("올바른 이메일 형식이 아닙니다."),
  forgetUserName: yup
    .string()
    .required("이름을 입력하세요.")
    .min(1, "이름을 입력하세요."),
});
